import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface BlockUserInput {
  id: string;
  value: string | Array<string> | null;
}

export interface PlainTextTableMap {
  [tableId: string]: {
    plainTextTable: Array<Array<string>>;
    dataFrameName: string;
  };
}

export interface CanvasSubmitParams {
  buttonId: string;
  blockUserInputs: Array<BlockUserInput>;
  plainTextTableMap: PlainTextTableMap;
}

export interface CanvasSubmitResponse {
  deliveryStatus: 'success' | 'failure';
}

export function submitCanvas(canvasId: string, params: CanvasSubmitParams): Promise<CanvasSubmitResponse> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/benchling-app-canvases/${canvasId}/interaction`,
    data: params,
  });
}

export interface NoteLinkedAppCanvasCreateParams {
  featureDeveloperDefinedId: string;
  appInstallationId: string;
}

export interface NoteLinkedAppCanvasCreateResponse {
  deliveryStatus: 'success' | 'failure';
}

export function noteLinkedAppCanvasCreate(
  entryId: string,
  provenanceUuid: string,
  params: NoteLinkedAppCanvasCreateParams
): Promise<NoteLinkedAppCanvasCreateResponse> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/note-linked-app-canvases/${entryId}/${provenanceUuid}:create-canvas`,
    data: params,
  });
}

export interface BulkArchiveCanvasParams {
  canvasIds: Array<string>;
  reason: string;
}

export interface BulkArchiveCanvasResponse {
  archivedItemIds: Array<string>;
}

export function bulkArchiveCanvases(params: BulkArchiveCanvasParams): Promise<BulkArchiveCanvasResponse> {
  return net.postJSONPromise({
    url: '/1/api/benchling-app-canvases:archive',
    data: params,
  });
}
